import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Flex, Heading } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import FaqCategory from '@/propTypes/FaqCategory';
import Category from './components/Category';

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  cursor: pointer;
`;

const PopularCategories = ({ categories }) => {
  if (isEmpty(categories)) {
    return null;
  }

  return (
    <Box bg="greys.porcelain" py={['8', null, '16']}>
      <Container>
        <Heading.h3 textStyle="h4" pb="4">
          Popular topics
        </Heading.h3>
        <Wrapper
          flexDirection={['column', null, 'row']}
          justifyContent={['center', null, 'flex-start']}
        >
          {categories.map((category) => (
            <Category key={category.slug} category={category} />
          ))}
        </Wrapper>
      </Container>
    </Box>
  );
};

PopularCategories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape(FaqCategory)).isRequired,
};

export default PopularCategories;
